import React from 'react';
import styled, { css } from 'styled-components';
import { space, layout, position, color, typography, flexbox, border, display, shadow } from 'styled-system';

export const Box = styled.div`
  ${shadow};
  ${space};
  ${layout};
  ${position};
  ${color};
  ${typography};
  ${border}
  ${display}
`;

export const Flex = styled(Box)`
  ${flexbox}
  display: flex;
  ${props => props.column && css`flex-direction: column;`};
  ${props => props.wrap && css`flex-wrap: wrap;`};
`;

export const ResponsiveFlex = styled(Box)`
  ${flexbox}
`
